<!-- Progress dashboard starts -->
<div class="page-container">
  <div class="page-heading">
    <div class="d-flex align-items-center justify-content-end">
      @if (hasInverters) {
        <select
          class="form-select form-select-sm w-auto"
          (change)="onLayerChange($event.target.value)">
          <option value="all"       [selected]="layerFilter === 'all'">{{'planner.projectDashboard.all' | translate}}</option>
          <option value="frames"    [selected]="layerFilter === 'frames'">{{'planner.projectDashboard.frame' | translate}}</option>
          <option value="inverters" [selected]="layerFilter === 'inverters'">{{'planner.projectDashboard.inverter' | translate}}</option>
        </select>
      }
    </div>
    <h3>
      <img class="nav-icon" src="assets/icons/list_alt_black_24dp.svg">
      <span class="page-title">{{'sideNavigation.titleDashboard' | translate}}</span>
    </h3>
    <div class="d-flex flex-wrap">
      <div class="d-flex align-items-center me-2">
        <div class="blue-text me-1">All</div>
        <div class="dot" [ngStyle]="{'background-color': interruptedColor}"></div>
        {{'basic.interrupted' | translate}}
      </div>
      <div class="d-flex align-items-center me-2">
        <div class="dot" style="background-color: white; border: 1px solid red"></div>
        {{'basic.deviation' | translate}}
      </div>
      @if (checkLength(allStates.states, 1) > 0) {
        <div class="w-100"></div>
        <div class="blue-text me-1">
          @if (customerId === 2) {
            <span>String</span>
          }
          @if (customerId !== 2) {
            <span>Frame</span>
          }
        </div>
        @for (status of allStates.states| filterStatesByType: 1; track $index) {
          <div class="d-flex align-items-center me-2">
            <div class="dot" [ngStyle]="{'background-color': status.color}"></div>
            {{ status.definition }}
          </div>
        }
      }
      @if (checkLength(allStates.states, 2) > 0) {
        <div class="w-100"></div>
        <div class="blue-text me-1">Inverters</div>
        @for (status of allStates.states| filterStatesByType: 2; track $index) {
          <div class="d-flex align-items-center me-2">
            <div class="dot" [ngStyle]="{'background-color': status.color}"></div>
            {{ status.definition }}
          </div>
        }
      }
      @if (checkLength(allStates.states, 3) > 0) {
        <div class="w-100"></div>
        <div class="blue-text me-1">Frames(checkup)</div>
        @for (status of allStates.states| filterStatesByType: 3; track $index) {
          <div class="d-flex align-items-center me-2">
            <div class="dot" [ngStyle]="{'background-color': status.color}"></div>
            {{ status.definition }}
          </div>
        }
      }
      @if (checkLength(allStates.states, 4) > 0 || checkLength(allStates.states, 5) > 0) {
        <div class="w-100"></div>
        <div class="blue-text me-1">Frames(checkup)</div>
        @for (status of ((allStates.states | filterStatesByType: 4)
          .concat(allStates.states | filterStatesByType: 5)) | uniqueItems:'definition'; track $index) {
          <div
            class="d-flex align-items-center me-2">
            <div class="dot" [ngStyle]="{'background-color': status.color}"></div>
            {{ status.definition }}
          </div>
        }
      }
    </div>
  </div>
  <div class="page-content">

    <div class="map-height">
      <div id="mapProject" class="map-container structure-child"></div>
    </div>
    @if (showSidebar) {
      <div class="rightsidebar">
        <div class="sidebarcontent">
          <img src="assets/icons/close_red_24dp.svg" class="close-btn" (click)="closeSidebar()" />
          @if (selectedMarker.identifier) {
            <h2>
              @if (customerId === 2 && selectedMarker.transformer) {
                <span>{{ selectedMarker.transformer }} - {{selectedMarker.inverter}}@if (selectedMarker.circuit) {
                  <span> - {{selectedMarker.circuit}}</span>
                }</span>
              }
              @if (customerId === 2 && !selectedMarker.transformer) {
                <span>{{selectedMarker.identifier}}</span>
              }
              @if (customerId !== 2 && customerId !== 4) {
                <span>{{selectedMarker.id}}</span>
              }
              @if (customerId === 4) {
                <span>{{selectedMarker.identifier}}</span>
              }
            </h2>
          }
          @if (!selectedMarker.identifier && selectedMarker.inverter) {
            <h2>{{ selectedMarker.transformer }} - {{selectedMarker.inverter}}</h2>
          }
          @if (selectedMarker.status_id) {
            <div>{{ 'planner.projectDashboard.currentPhase' | translate }}: {{getStatusDefinition()}}</div>
          }
          @if (selectedMarker.images) {
            <div>
              @for (img of selectedMarker.images; track $index) {
                <img src="{{img.url}}" alt="{{img.title}}" class="thumbnail" (click)="selectedImage = img.url" />
              }
            </div>
          }
          <hr>
            <h4>{{ 'planner.projectDashboard.reports' | translate }} (
              @if (selectedMarker.images) {
                <span>{{selectedMarker.imagecount}}</span>
              }
              @if (!selectedMarker.images) {
                <span>0</span>
              }
            )</h4>
            @for (state of allStates.states | filterStatesByType: type; track $index) {
              <div>
                <span class="dot" [ngStyle]="{'background-color': state.color}"></span>{{ state.definition }}
                @for (report of getStatusReports(state.state, selectedMarker); track $index) {
                  <div>
                    <div>
                      <span class="blue-text">{{ formatReportDateTime(report.created) }}</span>
                      @if (report.notes) {
                        <br>
                        }
                        @if (report.notes) {
                          <span class="text-break"><img class="person-icon" src="assets/icons/comment_24dp_blue.svg"> {{ report.notes }}</span>
                        }
                        <br>
                          <img class="person-icon" src="assets/icons/person_blue_24dp.svg"> {{report.firstname}} {{report.lastname}}
                        </div>
                      </div>
                    }
                    <div>
                      <label class="cursor-pointer" (click)="state.show = !state.show">{{ 'planner.projectDashboard.images' | translate }} ({{ selectedMarker?.statuses?.[state.id]?.count || 0 }})</label>
                      <input class="cursor-pointer" type="radio" [checked]="state.show" (click)="state.show = !state.show">
                    </div>
                    @if (selectedMarker?.statuses?.[state.id]?.images && state.show) {
                      <div class="panel">
                        @for (img of selectedMarker.statuses[state.id].images; track $index) {
                          <img src="{{img.url}}" alt="{{img.title}}" class="thumbnail" (click)="selectedImage = img.url" />
                        }
                      </div>
                    }
                    <hr>
                    </div>
                  }
                </div>
              </div>
            }

            @if (showBaseSidebar) {
              <div class="rightsidebar base-sidebar">
                <div class="sidebarcontent">
                  <img src="assets/icons/close_red_24dp.svg" class="close-btn" (click)="closeSidebar()" />
                  <h2 class="title">{{ 'planner.projectDashboard.baseLog' | translate }}</h2>
                  <div>
                    <h2 class="identifier">{{ selectedBase?.id }}. {{ selectedBase?.identifier }}</h2>
                    @if (!selectedBaseReports?.length) {
                      <h4 class="no-reports">
                        {{ 'planner.projectDashboard.noReportsYet' | translate }}
                      </h4>
                    }
                    @for (report of selectedBaseReports; track $index) {
                      <div class="report">
                        <div class="timestamp">{{ report.attend_time }}</div>
                        <div class="name">{{ report.attendee_name }}</div>
                        <hr>
                          <div class="notes">{{ report.notes }}</div>
                          @if (report.images?.length) {
                            <div class="pictures">
                              @for (img of report.images; track $index) {
                                @if (img.url) {
                                  <img src="{{img.url}}" alt="{{img.title}}" class="thumbnail"
                                    (click)="selectedImage = img.url" />
                                } @else {
                                  <div class="spinner-border spinner-border-sm" role="status">
                                    <span class="visually-hidden"></span>
                                  </div>
                                }
                              }
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </div>
                </div>
              }

              @if (showRouteSidebar) {
                <div class="rightsidebar route-sidebar">
                  <div class="sidebarcontent">
                    <img src="assets/icons/close_red_24dp.svg" class="close-btn" (click)="closeSidebar()" />
                    <h2 class="title">{{ 'planner.routePlanning.route' | translate }}</h2>
                    <div>
                      <div class="route-info">
                        <div class="info-row">
                          <span class="label">ID:</span>
                          <span class="value">{{ selectedRoute?.id }}</span>
                        </div>
                        @if (selectedRoute?.identifier) {
                          <div class="info-row">
                            <span class="label">{{ 'planner.routePlanning.identifier' | translate }}:</span>
                            <span class="value">{{ selectedRoute?.identifier }}</span>
                          </div>
                        }
                        @if (selectedRoute?.notes) {
                          <div class="info-row">
                            <span class="label">{{ 'planner.routePlanning.notes' | translate }}:</span>
                            <span class="value">{{ selectedRoute?.notes }}</span>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              }

              @if (showRouteNoteSidebar) {
                <div class="rightsidebar route-note-sidebar">
                  <div class="sidebarcontent">
                    <img src="assets/icons/close_red_24dp.svg" class="close-btn" (click)="closeSidebar()" />
                    <h2 class="title">{{ 'planner.routePlanning.routeNote' | translate }}</h2>
                    <div>
                      <div class="route-note-info">
                        <div class="info-row">
                          <span class="label">ID:</span>
                          <span class="value">{{ selectedRouteNote?.id }}</span>
                        </div>
                        <div class="info-row">
                          <span class="label">{{ 'planner.routePlanning.route' | translate }} ID:</span>
                          <span class="value">{{ selectedRouteNote?.route_id }}</span>
                        </div>
                        <div class="notes-section">
                          <span class="label">{{ 'planner.routePlanning.notes' | translate }}:</span>
                          <p class="notes-text">{{ selectedRouteNote?.notes }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }

              @if (pageLoading) {
                <div class="justify-content-center w-100 d-flex">
                  @if (pageLoading) {
                    <load-spinner></load-spinner>
                  }
                </div>
              }
              @if (!pageLoading) {
                <section class="section">
                  <h4>{{'planner.projectDashboard.titleStages' | translate}}</h4>
                  @for (state of filterNotStartedState(allStates.states); track $index) {
                    <div class="card shadow-sm ">
                      <div class="row ml-1 mb-1">
                        <div class="col-4">
                          <h4><span class="dot" [ngStyle]="{'background-color': state.color}"></span> {{state.definition}}</h4>
                        </div>
                        <div class="col-4">
                          <h4>{{'planner.projectDashboard.wholeProject' | translate}}</h4>
                          <div>
                            <div>{{'basic.done' | translate }}: <span class="green-text">
                              @if (state.type !== 3) {
                                <span>{{state.workorders.totaldone}}</span>
                              }
                              @if (state.type === 3) {
                                <span>{{getDoneAmount(state)}}</span>
                              }
                            / {{getAmount(state)}}</span>
                          </div>
                          <div class="progress progress-primary">
                            <div class="progress-bar" role="progressbar"
                        [ngStyle]="setProgress(
                          state.type === 3 ? getDoneAmount(state) : state.workorders.totaldone,
                          getAmount(state),
                          '#10A231'
                        )" aria-valuenow="0"
                              aria-valuemin="0" aria-valuemax="100">
                            </div>
                          </div>
                        </div>
                        @if (state.type !== 3) {
                          <div>
                            {{'planner.projectDashboard.interrupted' | translate }}: <span [ngClass]="state.workorders.totalinterrupted > 0 ? 'red-text' : '' ">{{state.workorders.totalinterrupted}}/{{getAmount(state)}}</span>
                            <div class="progress progress-primary">
                              <div class="progress-bar" role="progressbar"
                                [ngStyle]="setProgress(state.workorders.totalinterrupted, getAmount(state), '#bd2828')" aria-valuenow="0"
                                aria-valuemin="0" aria-valuemax="100">
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                }
              </section>
            }

            <!-- Full-size Image Modal -->
            @if (selectedImage) {
              <div class="modal" (click)="selectedImage = null">
                <div class="modal-content" (click)="$event.stopPropagation()">
                  <span class="close" (click)="selectedImage = null">&times;</span>
                  <img [src]="selectedImage" class="image-size-full">
                </div>
              </div>
            }
          </div>
        </div>
        <!-- Project dashboard ends -->
